export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v1/assets/celebration_astronaut-1137f715f884854fe9aacaff7dd3b83d.svg";